interface TableSkeletonProps {
  rows?: number;
  columns?: number;
}

const COL_WIDTHS = [
  ['w-32', 'w-24', 'w-28', 'w-20', 'w-16', 'w-20', 'w-24', 'w-20'],
  ['w-24', 'w-20', 'w-16', 'w-28', 'w-20', 'w-24', 'w-16', 'w-28'],
  ['w-28', 'w-32', 'w-20', 'w-16', 'w-24', 'w-16', 'w-20', 'w-24'],
  ['w-20', 'w-16', 'w-24', 'w-28', 'w-32', 'w-20', 'w-28', 'w-16'],
  ['w-36', 'w-24', 'w-16', 'w-20', 'w-28', 'w-16', 'w-24', 'w-20'],
];

export function TableSkeleton({ rows = 5, columns = 6 }: TableSkeletonProps) {
  return (
    <div className="table-loading-skeleton">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-100">
              {Array.from({ length: columns }).map((_, i) => (
                <th key={i} className="px-4 py-3 text-right">
                  <div className="skeleton h-3 w-16 rounded" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
              <tr key={rowIndex} className="border-b border-gray-50">
                {Array.from({ length: columns }).map((_, colIndex) => (
                  <td key={colIndex} className="px-4 py-3.5">
                    <div
                      className={`skeleton h-4 rounded ${COL_WIDTHS[rowIndex % COL_WIDTHS.length][colIndex % 8]}`}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
